import usePDPContext from './usePDPContext';
const DEFAULT_VALUE = {};
const usePDPStockAvailability = () => {
  return usePDPContext()?.stockAvailability ?? DEFAULT_VALUE;
};
export default usePDPStockAvailability;